import HireDialog from './HireDialog';
import InviteForInterviewConfirm from './InviteForInterviewConfirm';
import InviteForInterviewDialog from './InviteForInterviewDialog';
import RejectDialog from './RejectDialog';
import TableAssessmentResetDialog from './TableAssessmentResetDialog';

interface DialogsProps {
    assessmentName: string;
    onAssessmentReset?: () => void;
}

function Dialogs({ assessmentName, onAssessmentReset }: DialogsProps) {
    return (
        <>
            <RejectDialog assessmentName={assessmentName} />
            <InviteForInterviewDialog assessmentName={assessmentName} />
            <InviteForInterviewConfirm />
            <HireDialog />
            <TableAssessmentResetDialog onAssessmentReset={onAssessmentReset} />
        </>
    );
}

export default Dialogs;
